import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles/index'
import {
  Button,
  Card,
  CardContent,
  FormControl,
  SnackbarContent,
  Input,
  InputLabel,
  Typography,
} from '@material-ui/core'
import classNames from 'classnames'
import _ from 'lodash'
import {toast} from 'react-toastify'
import {FuseAnimate} from '@fuse'
import {Mutation, Query} from 'react-apollo'

import { LOGIN } from '../../../graphql/mutation'
import { USER } from '../../../graphql/query'
import { setLoginToken } from '../../../utils'

const styles = theme => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})

class LoginPage extends Component {
  state = {
    email: '',
    password: '',
    remember: true,
    error: false,
  }

  handleChange = event => {
    this.setState(
      _.set(
        { ...this.state },
        event.target.name,
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value,
      ),
    )
  }

  render() {
    const { classes } = this.props
    const { email, password } = this.state

    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <Query query={USER}>
          {({ loading, data }) => {
            if (loading || !data.me) return null
            return <Redirect to="/auth" />
          }}
        </Query>
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                {this.state.error && (
                  <SnackbarContent
                    variant="warning"
                    aria-describedby="client-snackbar"
                    message="Login Failed, Please check your username or password."
                  />
                )}
                <img
                  className="w-128 m-32"
                  src="assets/images/logos/deeple_dark.png"
                  alt="logo"
                />

                <Typography variant="title" className="mt-16 mb-32">
                  LOGIN TO YOUR ACCOUNT
                </Typography>
                <Mutation
                  mutation={LOGIN}
                  refetchQueries={re => {
                    const token = re.data.login
                    if (token) {
                      setLoginToken(token)
                    }

                    return [{ query: USER }]
                  }}
                >
                  {(login, { loading }) => {
                    return (
                      <form
                        name="loginForm"
                        noValidate
                        className="flex flex-col justify-center w-full"
                        onSubmit={e => {
                          e.preventDefault()
                          login({
                            variables: {
                              email: this.state.email,
                              password: this.state.password,
                            },
                          }).catch(loginError => {
                            loginError.graphQLErrors.forEach(({ message }) => {
                              toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT,
                              })
                            })
                          })
                        }}
                      >
                        <FormControl className="mb-16" fullWidth required>
                          <InputLabel>Email</InputLabel>
                          <Input
                            type="email"
                            name="email"
                            value={email}
                            onChange={this.handleChange}
                          />
                        </FormControl>
                        <FormControl className="mb-16" fullWidth required>
                          <InputLabel>Password</InputLabel>
                          <Input
                            type="password"
                            name="password"
                            value={password}
                            onChange={this.handleChange}
                          />
                        </FormControl>
                        <div
                          style={{ display: 'none' }}
                          className="flex items-center justify-between"
                        >
                          <Link className="font-medium" to="/forgot-password">
                            Forgot Password?
                          </Link>
                        </div>
                        <Button
                          variant="raised"
                          type="submit"
                          className="w-224 mx-auto mt-16"
                          aria-label="LOG IN"
                          disabled={loading}
                          style={{ background: '#663EE8', color: 'white' }}
                        >
                          LOGIN
                        </Button>
                      </form>
                    )
                  }}
                </Mutation>

                <div
                  style={{ display: 'none' }}
                  className="flex flex-col items-center justify-center pt-32 pb-24"
                >
                  <span className="font-medium">Don't have an account?</span>
                  <Link className="font-medium" to="/register">
                    Create an account
                  </Link>
                </div>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(LoginPage)



// WEBPACK FOOTER //
// ./src/main/content/login/LoginPage.js